<div id="loaderContainer">
    <img height="75" id="progressImg" src="https://cdn-titan.nextsphere.com/images/ns-processing.gif" alt="processing bar">
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/impersonation.component.html